export const SliceName = {
  SESSION: "session",
} as const;

export type SliceNameType = (typeof SliceName)[keyof typeof SliceName];

export const PersistKey = {
  SESSION: "rtk:session",
} as const;

export type PersistKeyType = (typeof PersistKey)[keyof typeof PersistKey];
